(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[392],{

/***/ 70361:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/kyc-workflow-automation",
      function () {
        return __webpack_require__(44926);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55123:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Acuris.0680843c.png","height":120,"width":247,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEX////7+Pj////T09Pk39/16Onvt73jsbl+6eYYAAAAAnRSTlP7/ULXe+8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAjSURBVHicJcnBDQAgDMSwlFxh/42RWn/NWVC3TQL9oloAUx8GCgBPMJbqSgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 75774:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Ekata.aa8b302d.png","height":40,"width":191,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEU9NZM+NZM+NJM+NZQ9NpQ/NJLI+BgAAAAABnRSTlOMfK/AZ0TkXDkGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgZmRgZGBgYGJgZmRgYGRlYQIAALMAGNMGZ/oAAAAASUVORK5CYII="});

/***/ }),

/***/ 5546:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Nominodata.ea76493a.png","height":60,"width":159,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAJ1BMVEX5+v3+4tnz1s9UYZS7vM6Oqczx3dn/7eNXTnJnapXKy9v+7OZFd6qJfi2dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVR4nGNg5WFhZ2Rk5GZg5mBmZGJiYmNg4eRiAAEABecAXV/0Q/UAAAAASUVORK5CYII="});

/***/ }),

/***/ 91167:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Seon.7777ae5b.png","height":100,"width":237,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEX////9///p+fi97evy+/vm+Par6OKE29x32NCkhKHVAAAAAXRSTlPzZFJ7wAAAAAlwSFlzAAALEwAACxMBAJqcGAAAACBJREFUeJwFwYEBADAIwrAioPv/4iWoO6lAfr4zaLaJ+ARpAFDgwnxBAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 74246:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/TeleSign.f5f1cb9e.png","height":50,"width":221,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAUOcAUecAUecAUegAUOcAUucAUOfDDFUdAAAAB3RSTlM4cmZEUI+3D6RsOwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGNiZmZgYWBgYGRgYWRiYmUEAAFdACPrOEHyAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 25749:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/datazoo.5789f41f.png","height":50,"width":170,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEVYwG5awW9YwG1YwW6XVytdAAAABHRSTlMiOElfSb8NLgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABhJREFUeJwFwQEBAAAAgiC1/58DKFFgaXEAqQATUol+5AAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 41703:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/pipl.f87f322b.svg","height":80,"width":130});

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Demyst.5001eb93.svg","height":22,"width":16});

/***/ }),

/***/ 44926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ kyc_workflow_automation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/TitleSection.jsx
var TitleSection = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/DataPartners.jsx
var DataPartners = __webpack_require__(83570);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/Resources.jsx + 1 modules
var Resources = __webpack_require__(82558);
// EXTERNAL MODULE: ./src/landingPage/datasets/usecases/kyc.js + 3 modules
var kyc = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/landingPage/views/Usecases/components/Recipes.jsx + 1 modules
var Recipes = __webpack_require__(41974);
;// CONCATENATED MODULE: ./src/landingPage/views/Usecases/KYC/KYC.jsx







// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";
var KYC = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "kyc_landing",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection/* default */.Z, {
                data: kyc/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Recipes/* default */.Z, {
                data: kyc/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataPartners/* default */.Z, {
                dataPartners: kyc/* default.dataPartners */.Z.dataPartners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Resources/* default */.Z, (0,_object_spread/* default */.Z)({}, kyc/* default */.Z))
        ]
    });
};

;// CONCATENATED MODULE: ./pages/use-cases/kyc-workflow-automation.jsx




var KycPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/use-cases/kyc-workflow-automation",
                title: meta/* meta.usecases.kyc.title */.$.usecases.kyc.title,
                description: meta/* meta.usecases.kyc.description */.$.usecases.kyc.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KYC, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var kyc_workflow_automation = (KycPage);


/***/ }),

/***/ 21395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ kyc; }
});

// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Acuris.png
var Acuris = __webpack_require__(55123);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Nominodata.png
var Nominodata = __webpack_require__(5546);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/ZeroBounce.svg
/* harmony default export */ var ZeroBounce = ({"src":"/_next/static/media/ZeroBounce.9cc9adbd.svg","height":45,"width":157});
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/Maxmind.png
/* harmony default export */ var Maxmind = ({"src":"/_next/static/media/Maxmind.4fb26732.png","height":76,"width":114,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEX+/v7z9/rO6vnW19nO0dSJbbZ4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAG0lEQVR4nGNgQAOMYAIEGFiYmZmYmJjAImAAAAHBABrISOw1AAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Seon.png
var Seon = __webpack_require__(91167);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/pipl.svg
var pipl = __webpack_require__(41703);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/datazoo.png
var datazoo = __webpack_require__(25749);
;// CONCATENATED MODULE: ./src/landingPage/assets/company-logos/GlobalDataConsortium.png
/* harmony default export */ var GlobalDataConsortium = ({"src":"/_next/static/media/GlobalDataConsortium.d2c5fe64.png","height":115,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEUdVpEvW4McWJYgWJD/NwB8kJDE0dKUvNqjjnl9mqR6qMi64ftLgu7uAAAAC3RSTlMUNSkLAkW09R5/7Y6Ex1UAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAkSURBVHicY+DgZGVhAAE2dnZGRkZGBgY2bi5GJiYmBgaoFDMACJIAcsIaqDUAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/TeleSign.png
var TeleSign = __webpack_require__(74246);
// EXTERNAL MODULE: ./src/landingPage/assets/company-logos/Ekata.png
var Ekata = __webpack_require__(75774);
;// CONCATENATED MODULE: ./src/landingPage/datasets/usecases/kyc.js










var data = {
    usecaseInfo: {
        name: "KYC Workflow Automation",
        description: "A single platform for seamless onboarding and verification of customers globally."
    },
    recipesInfo: {
        title: "Onboard customers in seconds",
        description: "Access API-ready solutions for identity verification, fraud risk, global AML and watchlist screening, social media presence, and financial verification, among many others."
    },
    recipes: [
        {
            type: "People Data",
            title: "Identity Verification",
            description: "Verify the name, address, and phone number of an individual."
        },
        {
            type: "People Data",
            title: "Watchlist and Fraud Screening",
            description: "Check an individual's presence in international AML and fraud watchlists and confirm the validity of a customer's provided email and phone."
        },
        {
            type: "People Data",
            title: "Email Identity Verification",
            description: "Validate an individual's email address based on its age, domain, risk-level across online activities, and mapping to the applicant."
        },
        {
            type: "People Data",
            title: "Phone Validation",
            description: "Validate an individual's phone number based on its connection status, carrier, risk-level, and mapping to the applicant."
        },
        {
            type: "People Data",
            title: "Consumer Social Media Profiles",
            description: "Check the presence and activity of social media profiles for an individual."
        },
        {
            type: "Other Data",
            title: "...And Many More",
            description: "Access 100's of api-ready recipes.",
            ctaText: "Access Recipe Catalog"
        }, 
    ],
    dataPartners: {
        title: "Sample Data Providers",
        description: "Access to hundreds of data partners worldwide",
        logos: [
            {
                name: "Global Data Consortium",
                img: GlobalDataConsortium
            },
            {
                name: "DataZoo",
                img: datazoo/* default */.Z
            },
            {
                name: "Nomino Data",
                img: Nominodata/* default */.Z
            },
            {
                name: "Acuris",
                img: Acuris/* default */.Z
            },
            {
                name: "PIPL",
                img: pipl/* default */.Z
            },
            {
                name: "Seon",
                img: Seon/* default */.Z
            },
            {
                name: "Maxmind",
                img: Maxmind
            },
            {
                name: "ZeroBounce",
                img: ZeroBounce
            },
            {
                name: "Ekata",
                img: Ekata/* default */.Z
            },
            {
                name: "TeleSign",
                img: TeleSign/* default */.Z
            }, 
        ]
    },
    resourcesInfo: {
        title: "Resources",
        description: "The latest news, technologies, and resources from our team."
    },
    resources: [
        {
            title: "Synthetic Identities, Genuine Fraud",
            url: "https://demyst.com/blog/synthetic-identities-genuine-fraud",
            featured_image: "https://cdn.buttercms.com/xb1BchPSRxKhMXwcPkyJ",
            date: "2021-10-16",
            description: "Synthetic identity theft is the fastest growing financial crime in the United States, and it poses serious risks for financial institutions (FIs) that are looking to streamline their customer onboarding in an effort to scale customer acquisition. Example industries include neo-banks, BNPL providers, and non-bank FIs with credit card products. Criminals can create “synthetic” identities to avoid detection by combining legitimate information, fabricated data, and online activity.",
            more: ""
        },
        {
            title: "Leveraging External Data to Address Rising Compliance Costs",
            url: "https://demyst.com/blog/leveraging-external-data-to-address-rising-compliance-costs",
            featured_image: "https://cdn.buttercms.com/czi74SoSpyDFZUuZrbTQ",
            date: "2021-10-08",
            description: "According to the 2021 True Cost of Financial Crime Compliance report, financial institutions spent $213.9 billion on regulatory compliance in 2020, up from $180.9 billion the previous year. These costs are expected to continue climbing — and the increased expenses will reduce productivity in APAC, EMEA and Latin America.",
            more: ""
        },
        {
            title: "How to Verify a U.S. Person’s Address",
            url: "https://demyst.com/blog/how-to-verify-a-us-persons-address",
            featured_image: "https://cdn.buttercms.com/HaKlsh1RRouay02w9jlQ",
            date: "2021-10-08",
            description: "Not only is address verification an important tool for fraud prevention, it can also be used to improve customer service by pre-filling forms, updating internal records, and making other enhancements to the user experience. However, companies need to actively monitor the accuracy of their records",
            more: ""
        },
        {
            title: "Mitigating Marketplace Onboarding Risk With External Data",
            url: "https://demyst.com/blog/mitigating-marketplace-onboarding-risk-with-external-data",
            featured_image: "https://cdn.buttercms.com/AejodJLgQ9c9Ahkuo32Q",
            date: "2021-09-20",
            description: "Last week, the Demyst team attended the Marketplace Risk Management Conference in San Francisco attended by notable players such as AirBnB, Uber, Lyft, and DoorDash, as well as dozens of emerging players and service providers (external data providers, legal firms, insurers, etc.). There was a notable buzz in the air as marketplaces, particularly in the ridesharing industry, are aiming for a strong comeback as economies recover from the slump associated with the pandemic. And as it was our first conference in a while, we welcomed it!",
            more: ""
        }, 
    ]
};
/* harmony default export */ var kyc = (data);


/***/ }),

/***/ 82558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Resources; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 14 modules
var format = __webpack_require__(4758);
// EXTERNAL MODULE: ./src/landingPage/assets/demyst_meta_image.png
var demyst_meta_image = __webpack_require__(34631);
;// CONCATENATED MODULE: ./src/landingPage/views/components/HighlightCard.jsx




/* harmony default export */ var HighlightCard = (/*#__PURE__*/react.forwardRef(function(param, ref) {
    var title = param.title, url = param.url, featured_image = param.featured_image, date = param.date, description = param.description, more = param.more;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: "highlight-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: url,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-card-image",
                    style: {
                        backgroundImage: "url(".concat(featured_image || demyst_meta_image/* default */.Z, ")")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-card-cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "highlight-card-textarea",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "highlight-card-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-description",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-date",
                            children: (0,format/* default */.Z)(new Date(date), "LLLL dd, yyyy")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "highlight-card-more",
                            children: more
                        })
                    ]
                })
            ]
        })
    }, title);
}));

// EXTERNAL MODULE: ./src/landingPage/views/components/Slider.jsx + 1 modules
var Slider = __webpack_require__(96777);
;// CONCATENATED MODULE: ./src/landingPage/views/Usecases/components/Resources.jsx





var Resources = function(param) {
    var resources = param.resources, resourcesInfo = param.resourcesInfo;
    var card = (0,react.useRef)(null);
    var ref = (0,react.useState)(), stepSize = ref[0], setStepSize = ref[1];
    (0,react.useEffect)(function() {
        var offsetWidth = card.current.offsetWidth;
        setStepSize(offsetWidth);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "usecases_resources_section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "usecases_resources_section-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: resourcesInfo.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "usecases_resources_section-subtitle",
                    children: resourcesInfo.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                    stepSize: stepSize,
                    children: resources.map(function(resource) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCard, (0,_object_spread/* default */.Z)({
                            ref: card
                        }, resource), resource.url);
                    })
                })
            ]
        })
    });
};
Resources.defaultProps = {
    resources: [],
    resourcesInfo: {}
};
/* harmony default export */ var components_Resources = (Resources);


/***/ }),

/***/ 38828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11723);



/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "usecases_title_section",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "usecases_title_section-container section-layout",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "usecases_title_section-text_container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: data.usecaseInfo.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "usecases_title_section-description",
                            children: data.usecaseInfo.description
                        }),
                        data.usecaseInfo.button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, {
                            download: data.usecaseInfo.button.download,
                            href: data.usecaseInfo.button.url,
                            variant: "inverted",
                            demystIcon: true,
                            children: data.usecaseInfo.button.text
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainCtaButton__WEBPACK_IMPORTED_MODULE_2__/* .MainCtaButton */ .T, {})
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 11723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ MainCtaButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LinkButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84135);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67474);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);







var MainCtaButton = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var sendCTAGaEvent = function() {
        (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_2__/* .sendGaEvent */ .k8)({
            action: "CTA Click - Contact Us",
            category: "Main CTA",
            label: "/contact "
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkButton__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        demystIcon: true,
        variant: "secondary",
        onClick: sendCTAGaEvent,
        href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.REQUEST_DEMO */ .s.REQUEST_DEMO
    }, props), {
        children: "Request a Demo"
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,1065,9774,2888,179], function() { return __webpack_exec__(70361); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);